import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const JobAlert = () => {
    const [emailAlerts, setEmailAlerts] = useState([]);

    // Fetch email alerts from the API
    useEffect(() => {
        const fetchEmailAlerts = async () => {
            try {
                const response = await axios.get("https://api.biznetusa.com/api/get-email-alerts");
                if (response.data && response.data.status === 200) {
                    setEmailAlerts(response.data.emails_alerts);
                } else {
                    toast.error("Failed to fetch email alerts.");
                }
            } catch (error) {
                console.error("Error fetching email alerts:", error);
                toast.error("An error occurred while fetching email alerts.");
            }
        };

        fetchEmailAlerts();
    }, []);

    return (
        <>
            <div className="container mt-4">
                <h2>Email Alerts</h2>
                {emailAlerts.length > 0 ? (
                    <table className="table table-bordered mt-3">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Email</th>
                                <th>Frequency</th>
                                <th>Created At</th>
                                <th>Updated At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emailAlerts.map((alert) => (
                                <tr key={alert.id}>
                                    <td>{alert.id}</td>
                                    <td>{alert.email}</td>
                                    <td>{alert.get_emails}</td>
                                    <td>{new Date(alert.created_at).toLocaleString()}</td>
                                    <td>{new Date(alert.updated_at).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="text-center mt-3">No email alerts available.</p>
                )}
            </div>
            <ToastContainer />
        </>
    );
};

export default JobAlert;
